<template>
    <v-form>
        <v-card>
            <v-toolbar dark color="primary">
                <v-toolbar-title>NHVAS Reporting</v-toolbar-title>
                <slot name="header"></slot>
            </v-toolbar>
            <v-card-text>
                <v-wait for="loading report" class="layout column fill-height">
                    <v-container grid-list-md v-if="step == 'input'">
                        <v-layout wrap>
                            <v-row justify="center">
                                <v-date-picker
                                    v-model="date"
                                    type="month"
                                    class="mt-2 mb-3 elevation-0"
                                    min="2019-01"
                                    :max="maxDate"
                                    no-title
                                ></v-date-picker>
                            </v-row>
                        </v-layout>
                    </v-container>
                    <v-container grid-list-md v-if="step == 'values'">
                        <v-layout wrap>
                            <v-flex xs4>
                                <v-chip small color="gray" v-if="garageName">{{garageName}}</v-chip>
                            </v-flex>
                            <v-flex xs6>Total NHVAS Units</v-flex>
                            <v-flex xs2>{{this.report.totalNhvasUnits}}</v-flex>
                            <v-flex xs4></v-flex>
                            <v-flex xs6>PM Services Completed</v-flex>
                            <v-flex xs2>{{this.report.totalPms}}</v-flex>
                            <v-flex xs4></v-flex>
                            <v-flex xs6>PM Services Completed Outside Tolerance</v-flex>
                            <v-flex xs2>{{this.report.pmServicesCompletedOutsideTolerance}}</v-flex>
                            <v-flex xs4 class="mt-5">
                                <v-chip small color="green" class="white--text">Current Month</v-chip>
                            </v-flex>
                            <v-flex xs6 class="mt-5">(A) Defects received</v-flex>
                            <v-flex xs2 class="mt-5">{{this.report.currentMonthDefectsReceived}}</v-flex>
                            <v-flex xs4></v-flex>
                            <v-flex xs6>(B) Defects Closed</v-flex>
                            <v-flex xs2>{{this.report.currentMonthDefectsClosed}}</v-flex>

                            <v-flex xs4 class="mt-5">
                                <v-chip small color="red lighten-4">Previous Month(s)</v-chip>
                            </v-flex>
                            <v-flex xs6 class="mt-5">(C) Defects Carried Forward</v-flex>
                            <v-flex xs2 class="mt-5">{{this.report.previousMonthsDefectsCarriedForward}}</v-flex>
                            <v-flex xs4></v-flex>
                            <v-flex xs6>(D) Defects Closed from Previous</v-flex>
                            <v-flex xs2>{{this.report.previousMonthsDefectsClosedFromPrevious}}</v-flex>
                            <v-flex xs4></v-flex>
                            <v-flex xs6>(E) Defects NOT Closed from Previous</v-flex>
                            <v-flex xs2>{{this.report.previousMonthsDefectsNotClosedFromPrevious}}</v-flex>

                            <v-flex xs4 class="mt-5">
                                <v-chip small color="red" class="white--text">Future Outstanding</v-chip>
                            </v-flex>
                            <v-flex xs6 class="mt-5">(F) Defects Carried Forward</v-flex>
                            <v-flex xs2 class="mt-5">{{this.report.futureOutstandingDefectsCarriedForward}}</v-flex>
                        </v-layout>
                    </v-container>
                </v-wait>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <slot name="actions"></slot>
                <v-btn color="primary" @click="submit" v-if="step == 'input'">Generate</v-btn>
                <v-btn color="primary" @click="init" v-if="step == 'values'">Start Over</v-btn>
            </v-card-actions>
        </v-card>
    </v-form>
</template>
<script>
import moment from 'moment';
import { Validator } from 'vee-validate';
import { GarageLocationStore } from '@/stores/GarageLocationStore';
import { DateFormat } from '@/plugins/date-filter';

export default {
    methods: {
        async init() {
            this.step = 'input';
            var date = new Date();
            date = new Date(date.setMonth(date.getMonth() - 1));
            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            this.maxDate = `${year}-${month}`;
            this.date = `${year}-${month}`;
            this.garageName = GarageLocationStore.methods.getGarageName(GarageLocationStore.data.userGarage);
        },
        async submit() {
            var garage = GarageLocationStore.data.userGarage;
            try {
                this.$wait.start('loading report');
                var dateParts = this.date.split('-');
                const response = await this.$api.get(`defects/report?garageId=${garage}&year=${dateParts[0]}&month=${dateParts[1]}`);
                this.report = response.data;
                this.step = 'values';
            } catch (err) {
                this.$toast.error('There was an error getting NHVAS Report data');
                return [];
            } finally {
                this.$wait.end('loading report');
            }
        }
    },
    data() {
        return {
            step: '',
            report: null,
            maxDate: null,
            date: null,
            garageName: null
        };
    }
};
</script>
